var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.525 8.59324C17.525 9.96475 16.4093 11.0806 15.0378 11.0806C13.6664 11.0806 12.5506 9.96475 12.5506 8.59329V2.48723C12.5506 1.11576 13.6664 0 15.0378 0C16.4093 0 17.525 1.11576 17.525 2.48723V8.59324Z",
    fill: "#00ADC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5123 11.0805H19.7282C19.3399 11.0805 19.0251 10.7657 19.0251 10.3774V8.59323C19.0251 7.22176 20.1409 6.106 21.5123 6.106C22.8838 6.106 23.9995 7.22176 23.9995 8.59323C23.9995 9.96474 22.8838 11.0805 21.5123 11.0805Z",
    fill: "#00ADC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48719 11.449H8.59311C9.96456 11.449 11.0803 10.3332 11.0803 8.96165C11.0803 7.59023 9.96456 6.47447 8.59311 6.47447H2.48719C1.11575 6.47451 0 7.59028 0 8.96169C0 10.3332 1.11575 11.449 2.48719 11.449Z",
    fill: "#00ADC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3766 4.97445H8.59255C7.22111 4.97445 6.10536 3.85869 6.10536 2.48723C6.10536 1.11576 7.22111 0 8.59255 0C9.964 0 11.0797 1.11576 11.0797 2.48723V4.27133C11.0797 4.65964 10.7649 4.97445 10.3766 4.97445Z",
    fill: "#00ADC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96169 12.9194C7.59024 12.9194 6.4745 14.0352 6.4745 15.4067V21.5127C6.4745 22.8842 7.59024 24 8.96169 24C10.3332 24 11.449 22.8842 11.449 21.5127V15.4067C11.449 14.0352 10.3332 12.9194 8.96169 12.9194Z",
    fill: "#00ADC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48719 12.9194H4.27132C4.65962 12.9194 4.97443 13.2342 4.97448 13.6225V15.4067C4.97448 16.7782 3.85868 17.8939 2.48719 17.8939C1.11575 17.8939 0 16.7782 0 15.4067C0 14.0352 1.11575 12.9194 2.48719 12.9194Z",
    fill: "#00ADC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5128 12.5509H15.4069C14.0354 12.5509 12.9197 13.6667 12.9197 15.0382C12.9197 16.4097 14.0354 17.5254 15.4069 17.5254H21.5128C22.8843 17.5254 24 16.4097 24 15.0382C24 13.6667 22.8842 12.5509 21.5128 12.5509Z",
    fill: "#00ADC6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6228 19.0254H15.4069C16.7784 19.0254 17.8941 20.1412 17.8942 21.5127C17.8942 22.8842 16.7784 24 15.4069 24C14.0354 24 12.9197 22.8842 12.9197 21.5127V19.7285C12.9197 19.3402 13.2345 19.0254 13.6228 19.0254Z",
    fill: "#00ADC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackHighlight);
export default __webpack_public_path__ + "static/media/slackHighlight.8f0a2d7eba03bc919a9ff6cdf9a8baa2.svg";
export { ForwardRef as ReactComponent };